import { TSession } from "@/types";

import API from "./api";

/** The account's signed-in devices (Mon compte > Sécurité). */
class SessionsClass {
	list = (): Promise<TSession[]> =>
		API.get("me/sessions").then((res) => res.data);

	/** Signs one device out: its session is revoked server-side. */
	revoke = (id: number): Promise<void> =>
		API.delete(`me/sessions/${id}`).then(() => undefined);

	/** Signs out every device but this one; resolves with how many. */
	revokeOthers = (): Promise<number> =>
		API.delete("me/sessions").then(
			(res) => (res.data as { signedOut: number }).signedOut
		);
}

const SessionsService = new SessionsClass();
export default SessionsService;
